var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: { width: "22", height: "22", xmlns: "http://www.w3.org/2000/svg" }
    },
    [
      _c(
        "g",
        {
          attrs: {
            transform: "translate(-1 -1)",
            fill: "none",
            "fill-rule": "evenodd"
          }
        },
        [
          _c("path", { attrs: { d: "M0 0h24v24H0z" } }),
          _vm._v(" "),
          _c("circle", {
            attrs: {
              stroke: "#FFF",
              "stroke-width": "3",
              fill: _vm.color,
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              cx: "12",
              cy: "12",
              r: "9"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              stroke: "#FFF",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              d:
                "M15.3639615 10.3455842l-3.8183766 3.8183766-2.54558442-2.5455844"
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }